import {
  getNextChapterLabel,
  getPreviousChapterLabel,
  hasNextChapter,
  hasNextQuestions,
  hasPreviousChapter,
  hasPreviousQuestions,
  selectNumberOfQuestionsForChapter,
} from 'affiny-core/redux/selectors/reflistsSelectors';
import { connect } from 'react-redux';
import { EReflistChapterName } from '../../api/repositories/reflists/reflists.types';
import { IRootState } from '../../state';

interface IOwnProps {
  chapterLabel: EReflistChapterName;
  questionIndex: number;
}

const mapStateToProps = (state: IRootState, ownProps: IOwnProps) => {
  const previousChapterLabel = getPreviousChapterLabel(
    state,
    ownProps.chapterLabel
  );
  const nbQuestionsForPreviousChapter = previousChapterLabel
    ? selectNumberOfQuestionsForChapter(state, previousChapterLabel)
    : 0;

  return {
    hasNextQuestions: hasNextQuestions(
      state,
      ownProps.chapterLabel,
      ownProps.questionIndex
    ),
    hasPreviousQuestions: hasPreviousQuestions(
      state,
      ownProps.chapterLabel,
      ownProps.questionIndex
    ),
    hasNextChapter: hasNextChapter(state, ownProps.chapterLabel),
    hasPreviousChapter: hasPreviousChapter(state, ownProps.chapterLabel),
    nextChapterLabel: getNextChapterLabel(state, ownProps.chapterLabel),
    previousChapterLabel,
    nbQuestionsForPreviousChapter,
  };
};

export type IPaginateQuestionContainerProps = ReturnType<
  typeof mapStateToProps
>;

export const paginateQuestionContainerFactory = connect(mapStateToProps);
